/* Etiquetas multiidoma en castellano. */
export default {
  "loginView.error": "Invalid username or password",
  "loginView.password": "Password",
  "loginView.submit": "Submit",
  "loginView.title": "Login",
  "loginView.username": "Username",
};
